module.exports = __webpack_public_path__ + "media/images/company/cp11-3aabf7e17dd7cbd5d530b96ce600ef4d.png";